import { useEffect, useState, useRef } from 'react';
import { usePaymentMessages } from '../../hooks';
import useConfigOptions from '../../hooks/useConfigOptions';
import { HugeiconsIcon } from '@hugeicons/react';
import { Search01Icon, ArrowDown01Icon, CheckmarkCircle01Icon } from '@hugeicons/core-free-icons';

function Filter({ setLoading, setTransactions }) {

    const { collectionStates } = useConfigOptions();
    const [matched, setMatched] = useState(collectionStates[0].value);
    const [open, setOpen] = useState(false);
    const ref = useRef(null);

    const { isLoading, transactions } = usePaymentMessages({ state: matched });

    useEffect(() => {
        const handler = (e) => {
            if (ref.current && !ref.current.contains(e.target)) setOpen(false);
        };
        document.addEventListener('mousedown', handler);
        return () => document.removeEventListener('mousedown', handler);
    }, []);

    useEffect(() => {
        setLoading(isLoading);
        setTransactions(transactions);
    }, [isLoading, transactions, setLoading, setTransactions]);

    const selected = collectionStates.find(s => s.value === matched) ?? collectionStates[0];

    return (
        <div className="flex items-center gap-2.5">
            <span className="hidden sm:flex items-center gap-1.5 text-sm text-gray-500 dark:text-gray-400">
                <HugeiconsIcon icon={Search01Icon} size={14} className="text-gray-400" />
                Filter by
            </span>
            <div ref={ref} className="relative">
                <button
                    onClick={() => setOpen(o => !o)}
                    className="flex items-center justify-between gap-2 px-3 py-1.5 rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700 text-sm font-medium text-gray-700 dark:text-gray-200 transition-colors min-w-[10rem]"
                >
                    <span>{selected.name}</span>
                    <HugeiconsIcon icon={ArrowDown01Icon} size={14} className={`text-gray-400 transition-transform shrink-0 ${open ? 'rotate-180' : ''}`} />
                </button>

                {open && (
                    <div className="absolute right-0 top-full mt-1.5 bg-white dark:bg-gray-800 rounded-xl shadow-xl border border-gray-100 dark:border-gray-700 py-1.5 z-50 min-w-[10rem] overflow-hidden">
                        {collectionStates.map((item) => (
                            <button
                                key={item.id}
                                onClick={() => { setMatched(item.value); setOpen(false); }}
                                className={`w-full flex items-center justify-between gap-3 px-3 py-2 text-sm transition-colors ${
                                    item.value === matched
                                        ? 'text-blue-600 dark:text-blue-400 bg-blue-50 dark:bg-blue-500/10 font-medium'
                                        : 'text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700'
                                }`}
                            >
                                <span>{item.name}</span>
                                {item.value === matched && (
                                    <HugeiconsIcon icon={CheckmarkCircle01Icon} size={15} className="text-blue-500 shrink-0" />
                                )}
                            </button>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}

export default Filter;
